var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTopBlockBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 84,
    viewBox: "0 0 146 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3698 12.2728C80.6228 12.1267 81.033 12.1267 81.286 12.2728L86.1214 15.0645C86.3744 15.2106 86.3744 15.4474 86.1214 15.5935L83.8422 16.9093C83.5892 17.0554 83.179 17.0554 82.9261 16.9093L78.0906 14.1176C77.8376 13.9715 77.8376 13.7347 78.0906 13.5886L80.3698 12.2728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7927 6.29585C60.0456 6.14978 60.4558 6.14978 60.7088 6.29585L65.5442 9.08758C65.7972 9.23364 65.7972 9.47046 65.5442 9.61652L63.2651 10.9324C63.0121 11.0785 62.6019 11.0785 62.3489 10.9324L57.5135 8.14067C57.2605 7.9946 57.2605 7.75779 57.5135 7.61172L59.7927 6.29585Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9051 3.34419C65.1581 3.19812 65.5682 3.19812 65.8212 3.34419L70.6567 6.13592C70.9097 6.28198 70.9097 6.5188 70.6567 6.66486L68.3775 7.98074C68.1245 8.1268 67.7143 8.1268 67.4613 7.98074L62.6259 5.18901C62.3729 5.04294 62.3729 4.80613 62.6259 4.66006L64.9051 3.34419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2963 8.51008C71.5493 8.36401 71.9595 8.36401 72.2125 8.51008L77.1757 11.3756C77.4287 11.5217 77.4287 11.7585 77.1757 11.9046L72.3403 14.6963C72.0873 14.8423 71.6771 14.8423 71.4241 14.6963L66.4609 11.8308C66.2079 11.6847 66.2079 11.4479 66.4609 11.3018L71.2963 8.51008Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2596 15.2258C75.5126 15.0797 75.9227 15.0797 76.1757 15.2258L81.0112 18.0175C81.2641 18.1636 81.2641 18.4004 81.0112 18.5465L78.732 19.8623C78.479 20.0084 78.0688 20.0084 77.8158 19.8623L72.9804 17.0706C72.7274 16.9245 72.7274 16.6877 72.9804 16.5417L75.2596 15.2258Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9905 5.84699C74.5199 6.15264 74.5199 6.64823 73.9905 6.95388C73.814 7.05577 73.814 7.22096 73.9905 7.32284L75.194 8.01768C75.447 8.16374 75.8572 8.16374 76.1101 8.01768L77.8888 6.99078C78.1431 6.84396 78.4879 6.7615 78.8474 6.76157C79.0546 6.76157 79.1584 6.61691 79.0119 6.5323L69.6556 1.13044C69.4026 0.984376 68.9924 0.984376 68.7394 1.13044L67.7384 1.70839C67.4854 1.85445 67.4854 2.09127 67.7384 2.23733L73.9905 5.84699Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6772 8.32687C79.5054 8.32687 79.3406 8.36628 79.2191 8.43642L78.0273 9.12454C77.7743 9.2706 77.7743 9.50742 78.0273 9.65349L79.2308 10.3483C79.4072 10.4502 79.6934 10.4502 79.8698 10.3483C80.3992 10.0427 81.2576 10.0427 81.787 10.3483L88.0391 13.958C88.2921 14.104 88.7023 14.104 88.9553 13.958L89.9563 13.38C90.2093 13.234 90.2093 12.9971 89.9563 12.8511L82.3099 8.43642C82.1884 8.36628 82.0237 8.32687 81.8518 8.32687L79.6772 8.32687Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6462 17.3595C69.1168 17.0538 69.1168 16.5582 69.6462 16.2526C69.8227 16.1507 69.8227 15.9855 69.6462 15.8836L68.4427 15.1888C68.1897 15.0427 67.7796 15.0427 67.5266 15.1888L65.7479 16.2157C65.4936 16.3625 65.1489 16.445 64.7893 16.4449C64.5821 16.4449 64.4783 16.5896 64.6248 16.6742L73.9811 22.076C74.2341 22.2221 74.6443 22.2221 74.8973 22.076L75.8983 21.4981C76.1513 21.352 76.1513 21.1152 75.8983 20.9691L69.6462 17.3595Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.958 14.8787C64.1298 14.8787 64.2946 14.8393 64.4161 14.7692L65.6079 14.0811C65.8609 13.935 65.8609 13.6982 65.6079 13.5521L64.4045 12.8573C64.228 12.7554 63.9419 12.7554 63.7654 12.8573C63.236 13.1629 62.3776 13.1629 61.8482 12.8573L55.5961 9.24764C55.3431 9.10158 54.9329 9.10158 54.6799 9.24764L53.6789 9.82559C53.4259 9.97165 53.4259 10.2085 53.6789 10.3545L61.3253 14.7692C61.4468 14.8393 61.6116 14.8787 61.7834 14.8787L63.958 14.8787Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.57639e-8,
    y: 0.264474,
    width: 24.3316,
    height: 18.5132,
    rx: 0.793421,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.4272 0.704502)",
    stroke: "white",
    strokeWidth: 0.528947
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9943 20.7793C56.7966 20.6197 54.3332 19.943 54.0617 18.5132M56.3691 23.3445C54.5111 23.0697 50.5579 21.906 49.6098 19.4497M55.1507 25.7462C52.6758 25.3547 47.306 23.709 45.6262 20.258M53.4178 28.0902C50.4029 27.6794 43.8102 25.7375 41.5583 21.2565",
    stroke: "white",
    strokeWidth: 1.37985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 77.1538 83.496)",
    stroke: "url(#paint0_linear_91802_90)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 66.8076 77.5223)",
    stroke: "url(#paint1_linear_91802_90)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91802_90",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91802_90",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTopBlockBg);
export default __webpack_public_path__ + "static/media/card-top-block-bg.9f5b484c8961bffad32361ce5535c520.svg";
export { ForwardRef as ReactComponent };